import { computed } from 'vue';
import useCallEndPointWith from '@/services/backend/useCallEndPointWith';

const user = () => {
  const {
    callEndpoint: getCall,
    endpointData,
    isLoading: isLoadingGet,
    userFriendlyError: errorGet,
  } = useCallEndPointWith('account');
  const {
    callEndpoint: updateCall,
    isLoading: isLoadingUpdate,
    userFriendlyError: errorUpdate,
  } = useCallEndPointWith('account');

  const fetchUserInfo = async () => {
    await getCall({ method: 'GET' });
  };

  const userInfo = computed(() => endpointData.value || {});

  const updateUserInfo = async (values) => {
    await updateCall({ method: 'POST', request: values });
  };

  return {
    fetchUserInfo,
    userInfo,
    isLoadingGet,
    isLoadingUpdate,
    updateUserInfo,
    errorGet,
    errorUpdate,
  };
};

export default user;
